SftpExportEditionController.$inject = ['$scope',
  '$translate',
  '$mdDialog',
  '$stateParams',
  'UserFactory',
  'StrategiesFactory',
  'AlertingFactory',
  'SftpExportsFactory',
  'AppFactory',
  'company',
  'sftpExport',
  'isCreation',
  'sftpServers'];
export function SftpExportEditionController($scope,
  $translate,
  $mdDialog,
  $stateParams,
  UserFactory,
  StrategiesFactory,
  AlertingFactory,
  SftpExportsFactory,
  AppFactory,
  company,
  sftpExport,
  isCreation,
  sftpServers) {

  $scope.submitSftpExport = submitSftpExport;
  $scope.cancel = cancel;

  init();

  function submitSftpExport() {
    $mdDialog.hide($scope.sftpExport);
  };

  function cancel() {
    $mdDialog.cancel();
  };

  function init() {
    if (isCreation) {
      sftpExport.data = {};
    }
    $scope.sftpExport = sftpExport;
    $scope.isCreation = isCreation;
    let titleKey = isCreation ? 'sftp-exports/edition/create-title' : 'sftp-exports/edition/edit-title';
    $scope.sftpServers = sftpServers;
    $scope.dialogTitle = $translate.instant(titleKey);
    $scope.languages = AppFactory.getAvailableLanguages();
    $scope.encodings = ['utf-8', 'utf-16'];
    $scope.normalize = [{ key: 'no', value: false }, { key: 'yes', value: true }];

    // handle old export format with boolean
    if ($scope.sftpExport.data.anonymize === true) {
      $scope.sftpExport.data.anonymize = 1
    } else if ($scope.sftpExport.data.anonymize === false) {
      $scope.sftpExport.data.anonymize = 0
    }
    $scope.anonymize = [{ key: 'sftp-exports/edition/anonymize-no', value: 0 },
    { key: 'sftp-exports/edition/anonymize-all', value: 1 },
    { key: 'sftp-exports/edition/anonymize-client-only', value: 2 },
    { key: 'sftp-exports/edition/anonymize-adviser-only', value: 3 }];

    $scope.export_types = [{ key: 'sftp-exports/edition/type/ftp-and-api', value: 0 },
    { key: 'sftp-exports/edition/type/api-only', value: 1 }];

    // Here what user sees is the inverse of what we have in backend
    $scope.no_create_zip_directory = [{ key: 'yes', value: false }, { key: 'no', value: true }];
  }

}
